// import CategoryBanner from "./../assets/category/oficedecor/subcategoryimage.jpg";

// import SubCategoryImage from "./../assets/subcategoryimage.webp";
import PrestigeBanner from "./../assets/category/prestige.webp";
import SpaceStylers from "./../assets/category/space-stylers.webp";
import MonumentsBanner from "./../assets/category/monuments.webp";
import EssenceofFormBanner from "./../assets/category/essence-of-form.webp";
import ArtInFormBanner from "./../assets/category/art-in-form.webp";
import FlameHoldersBanner from "./../assets/category/flame-holders.webp";
import WallMasterpiecesBanner from "./../assets/category/wall-masterpieces.webp";
import ReadDisplayBanner from "./../assets/category/read-display.webp";
import LightStyleBanner from "./../assets/category/light-style.webp";
import ATokenOfLoveBanner from "./../assets/category/a-token-of-love.webp";
import WarmSipsBanner from "./../assets/category/warm-sips.webp";
import GardenCharmBanner from "./../assets/category/garden-charm.webp";
import DeskEleganceBanner from "./../assets/category/desk-elegance.webp";
//import PerfumeBanner from "./../assets/category/parfumecat.webp";
import PerfumeBanner from "./../assets/category/categoryparfume.webp";

const categoryData = {
  category: [
    // {
    //   id: 101,
    //   categoryname: "Living Room",
    //   categorydesc: "Living Room DESC",
    //   categorymetakey: "mukemel,office,decor",
    //   categorybanner: CategoryBanner,
    //   categoryimage: CategoryImage,
    //   subcategories: [
    //     {
    //       id: 201,
    //       name: "Desk Decoration",
    //       subdesc: "Desk Decoration",
    //       subkey: "mukemel,decoration,desk",
    //       banner: CategoryBanner,
    //       image: SubCategoryImage,
    //       alt: "Decoration",
    //     },
    //     {
    //       id: 202,
    //       name: "Wall Decor Art",
    //       subdesc: "Wall Decor Art",
    //       subkey: "mukemel,decoration,desk",
    //       banner: CategoryBanner,
    //       image: SubCategoryImage,
    //       alt: "Decoration",
    //     },
    //   ],
    // },
    // {
    //   id: 102,
    //   categoryname: "Office Decor",
    //   categorydesc: "Office Decor DESC",
    //   categorymetakey: "mukemel,office,decor",
    //   categorybanner: CategoryBanner,
    //   categoryimage: CategoryImage,
    //   subcategories: [
    //     {
    //       id: 301,
    //       name: "Floor Sculptures",
    //       subdesc: "Floor Sculptures",
    //       subkey: "mukemel,decoration,desk",
    //       banner: CategoryBanner,
    //       image: SubCategoryImage,
    //       alt: "Decoration",
    //     },
    //   ],
    // },
    {
      id: 117,
      categoryname: "Perfume",
      categorydesc: "categories.perfume.desc",
      translationKey: "Perfume",
      categorymetakey: "categories.perfume.meta",
      categorybanner: "",
      categoryimage: PerfumeBanner,
      subcategories: [],
    },
    {
      id: 105,
      categoryname: "Prestige",
      categorydesc: "categories.prestige.desc",
      translationKey: "Prestige",
      categorymetakey: "categories.prestige.meta",
      categorybanner: "",
      categoryimage: PrestigeBanner,
      subcategories: [],
    },
    {
      id: 106,
      categoryname: "Space Stylers",
      categorydesc: "categories.spaceStylers.desc",
      translationKey: "Space Stylers",
      categorymetakey: "categories.spaceStylers.meta",
      categorybanner: "",
      categoryimage: SpaceStylers,
      subcategories: [],
    },
    {
      id: 107,
      categoryname: "Monuments",
      categorydesc: "categories.monuments.desc",
      translationKey: "Monuments",
      categorymetakey: "categories.monuments.meta",
      categorybanner: "",
      categoryimage: MonumentsBanner,
      subcategories: [],
    },
    {
      id: 108,
      categoryname: "Essence Of Form",
      categorydesc: "categories.essence_of_form.desc",
      translationKey: "Essence Of Form",
      categorymetakey: "categories.essence_of_form.meta",
      categorybanner: "",
      categoryimage: EssenceofFormBanner,
      subcategories: [],
    },
    {
      id: 109,
      categoryname: "Art In Form",
      categorydesc: "categories.art_in_form.desc",
      translationKey: "Art In Form",
      categorymetakey: "categories.art_in_form.meta",
      categorybanner: "",
      categoryimage: ArtInFormBanner,
      subcategories: [],
    },
    {
      id: 110,
      categoryname: "Flame Holders",
      categorydesc: "categories.flame_holders.desc",
      translationKey: "Flame Holders",
      categorymetakey: "categories.flame_holders.meta",
      categorybanner: "",
      categoryimage: FlameHoldersBanner,
      subcategories: [],
    },
    {
      id: 111,
      categoryname: "Wall Masterpieces",
      categorydesc: "categories.wall_masterpieces.desc",
      translationKey: "Wall Masterpieces",
      categorymetakey: "categories.wall_masterpieces.meta",
      categorybanner: "",
      categoryimage: WallMasterpiecesBanner,
      subcategories: [],
    },
    {
      id: 112,
      categoryname: "Read Display",
      categorydesc: "categories.read_display.desc",
      translationKey: "Read Display",
      categorymetakey: "categories.read_display.meta",
      categorybanner: "",
      categoryimage: ReadDisplayBanner,
      subcategories: [],
    },
    {
      id: 113,
      categoryname: "Light Style",
      categorydesc: "categories.light_style.desc",
      translationKey: "Light Style",
      categorymetakey: "categories.light_style.meta",
      categorybanner: "",
      categoryimage: LightStyleBanner,
      subcategories: [],
    },
    {
      id: 114,
      categoryname: "A Token Of Love",
      categorydesc: "categories.a_token_of_love.desc",
      translationKey: "A Token Of Love",
      categorymetakey: "categories.a_token_of_love.meta",
      categorybanner: "",
      categoryimage: ATokenOfLoveBanner,
      subcategories: [],
    },
    {
      id: 115,
      categoryname: "Warm Sips",
      categorydesc: "categories.warm_sips.desc",
      translationKey: "Warm Sips",
      categorymetakey: "categories.warm_sips.meta",
      categorybanner: "",
      categoryimage: WarmSipsBanner,
      subcategories: [],
    },
    {
      id: 116,
      categoryname: "Garden Charm",
      categorydesc: "categories.garden_charm.desc",
      translationKey: "Garden Charm",
      categorymetakey: "categories.garden_charm.meta",
      categorybanner: "",
      categoryimage: GardenCharmBanner,
      subcategories: [],
    },
    {
      id: 117,
      categoryname: "Desk Elegance",
      categorydesc: "categories.desk_elegance.desc",
      translationKey: "Desk Elegance",
      categorymetakey: "categories.desk_elegance.meta",
      categorybanner: "",
      categoryimage: DeskEleganceBanner,
      subcategories: [],
    },
  ],
};

export default categoryData;
